export const SET_TEAM_CONTEXT = "SET_TEAM_CONTEXT"
export const TEAM_IS_CONFIRMATION_MODAL = "TEAM_IS_CONFIRMATION_MODAL"
export const CLEAN_TEAM_CONTEXT = "CLEAN_TEAM_CONTEXT"